<div class="toast">
  <div class="content">
    <mat-icon aria-hidden="true">{{ icon }}</mat-icon>
    <p role="alert" [attr.aria-label]="message()">{{ message() }}</p>
  </div>

  <mat-icon aria-label="Close" (click)="remove()" aria-hidden="true">close</mat-icon>
</div>

<div class="toast-progress-track">
  <div class="toast-progress-bar" [style.width]="width() + '%'"></div>
</div>
